import { loadScript } from './loadScript'
import cpSite from './cpSite'
import config from './config'
/**
 * Всплывающая форма быстрой загрузки CSP
 */
let init = false

const cspGetForm = {
  depend: [
    'vue'
  ],
  state: {
    PATH: config.STATIC + 'view/csp_download_form/', // Место хранения дополнительных скриптов
    IMG: config.STATIC + 'view/csp_download_form/img/', // Место хранения изображений
    lib: config.DEVMODE ? ['js/cspGetForm/vue.template.b.js', 'js/cspGetForm/vue.run.js'] : [config.THEME + 'js/cspGetForm/vue.template.b.js', config.THEME + 'js/cspGetForm/vue.run.js'],
    isActive: false
  },
  activate: function () {
    // Не проводить повторную инициализацию
    if (init) {
      return this.app.cspWindowShow()
    }

    loadScript(this.state.lib[0]) // Загрузка и внедрение HTML шаблона Vue в body
    cpSite.module.vue.activate() // Включение библиотеки Vue
    loadScript(this.state.lib[1]) // Логика объекта Vue
    init = true
    this.state.isActive = true
  }
}

export default cspGetForm
